<div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Representantes</div>
    </div>
    <mat-form-field>
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field>
    <div class="contenedor-tabla">
        <mat-table
            class="servicios-tabla"
            #table
            [dataSource]="dataSource"
            matSort
            [@animateStagger]="{ value: '50' }"
            fusePerfectScrollbar
        >
            <ng-container matColumnDef="nombre">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Nombre</mat-header-cell
                >
                <mat-cell *matCellDef="let representante">
                    {{ representante.nombres }}

                    <button
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="editar(representante)"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="apellido">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Apellido</mat-header-cell
                >
                <mat-cell *matCellDef="let representante">
                    {{ representante.apellidos }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="rut">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Rut</mat-header-cell
                >
                <mat-cell *matCellDef="let representante">
                    <p>
                        {{ representante.rut }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="borrar">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Borrar</mat-header-cell
                >
                <mat-cell *matCellDef="let representante">
                    <p>
                        <button
                            mat-icon-button
                            type="button"
                            color="accent"
                            (click)="borrar(representante.nrRut)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </p>
                </mat-cell>
            </ng-container>

            <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>

            <mat-row *matRowDef="let sucursal; columns: displayedColumns">
            </mat-row>
        </mat-table>
        <mat-paginator
            #paginator
            [length]="dataSource?.filteredData?.length"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
    </div>
</div>
